import { paginationListToQueryString } from 'system/utils/list-object-to-query-string';
import { OperationObject } from 'system/utils/operation-object-to-query-string';
import { Operation } from 'shell/view-models/operation';
import { FiltersFunctions } from './types';
import { Order } from 'shell/view-models/order';

export const transformDataset = (values: FiltersFunctions): string => {
  const { orders, ...otherValues } = values;

  const transformedFilters: OperationObject = {
    codice: {
      value: otherValues.code,
      operation: Operation.EQUALS,
    },
    nome: {
      value: otherValues.description,
      operation: Operation.LIKE,
    },
    entita: { value: otherValues.entity },
  };

  const ordersToTransform = orders || {};

  const ordersMapped: Order = {
    codice: ordersToTransform.id,
    nome: ordersToTransform.function,
    entita: ordersToTransform.entity,
  };

  return `${paginationListToQueryString({
    filters: transformedFilters,
    orders: ordersMapped,
  })}`;
};
